$().ready(function(){
    window.csrf = $("head").find("meta[name=csrf]").attr("content");

    $('.cdropdown-title').click(function(e){
        e.preventDefault();
        $(this).parent().find('.cdropdown-area').toggle();
    });

    $(document).click(function(event) {
        $target = $(event.target);
        if(!$target.closest('.cdropdown-area').length && !$target.closest('.cdropdown-title').length) {
            $('.cdropdown-area').hide();
        }
    });
});
window.loading = function(){
    $('.loading').show();
}
window.stopLoading = function(){
    $('.loading').hide();
}
window.getParameterByName = function(name, url) {
    if (!url) url = window.location.href;
    name = name.replace(/[\[\]]/g, '\\$&');
    var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
        results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return '';
    return decodeURIComponent(results[2].replace(/\+/g, ' '));
}
